import i18n from "config/i18next";

i18n.addResources("es", "personal", {
  nameLabel: "Nombre/s *",
  namePlaceholder: "Ingresá el nombre",
  surnameLabel: "Apellido/s *",
  surnamePlaceholder: "Ingresá el apellido",
  identifierLabel: "{{identification}}",
  emailLabel: "Email",
  birthdateLabel: "Fecha de nacimiento",
  areaCodeLabel: "Código de área *",
  areaCodePlaceholder: "Ej: 011",
  phoneLabel: "WhatsApp *",
  phonePlaceholder: "Ej: 12345678",
  regionLabel: "Región *",
  regionPlaceholder: "Seleccioná la región",
  workzoneLabel: "Zonas de trabajo *",
  workzonePlaceholder: "Seleccioná la zona",
  comeFromLabel: "Canal de adquisición",
  comeFromCodeLabel: "Código del referido *",
  comeFromCodePlaceholder: "Ingresá el código",
  termsVersionLabel: "Versión de términos y condiciones",
  termsDateLabel: "Fecha de términos y condiciones",
  termsOutdatedTitle: "Términos y condiciones desactualizados",
  termsRequiredVersionMessage: "Versión requerida: {{currentVersion}}\nÚltima actualización: {{lastUpdate}}",
  termsNoVersionMessage: "No hay versiones de términos y condiciones disponibles.",
});
